<template>
  <div>
    <div class="view-order">
      <div class="bread">
        <router-link class="bread-item" to="/">上上签</router-link>
        <div class="bread-arrow">&gt;</div>
        <router-link class="bread-item" to="/orders">订单管理</router-link>
        <div class="bread-arrow">&gt;</div>
        <router-link class="bread-item" :to="'/orders/detail/'+oid">订单详情</router-link>
      </div>

      <div class="order-main">

        <!-- 办理进度 -->
        <schedule-block :schedule-arr="DM.schedule"></schedule-block>

        <order-tips></order-tips>

        <!-- 邮寄资料清单 -->
        <order-mail-list :order="DM" v-if="!changeMailListPosition(DM) && havePaperyMaterial && DM.visa_supplier_id !== 0" />
        <!--物流信息-->
        <!--goods_type==0:商品;goods_type==1:发票;goods_type==2:赴馆资料-->
        <!--商品 或者 寄送的赴馆资料未被签收的时候-->
        <order-express-routes :order="DM" v-if="hasReturnExpress" />

        <!--赴馆通知书  预约成功之后才展示-->
        <order-fg-notification :order="DM" v-if="isFgShow && earlistDateData" ref="orderFgNotification" :price="earlistDateData.interview_change_fee/100" :earlistDateData="earlistDateData" />

        <!--电子签证-->
        <order-elec-visa ref="orderElecVisa" @sendEmailEvent="sendEmailEvent" :order="DM" v-if="hasElecVisa" />

        <!-- 核对签证信息 -->
        <order-page-check :order="DM" class="order-page-check" />

        <!-- 申请人信息 -->
        <order-applicant-infos @refresh="getOrder" :order="DM" :showWaitCompleteMaterial="showWaitCompleteMaterial" :class="{'none-margin': changeMailListPosition(DM) || !havePaperyMaterial}" v-if="DM.applicant" @completeMaterial="completeMaterial" />

        <!--等待预约时候的已选择赴馆日期-->
        <order-fg-date :order="DM" v-if="isWaitOrderShow" />

        <!-- 拒签无忧 -->
        <order-reject-product :order="DM" v-if="DM.reject_product_set && DM.reject_product_set.reject_product_id" />

        <!-- 邮寄资料清单 -->
        <order-mail-list :order="DM" v-if="changeMailListPosition(DM) && havePaperyMaterial && DM.visa_supplier_id !== 0" :class="{'module-margin': true}" />

        <!-- 顺丰服务信息 -->
        <sf-pickup-service-info :order="DM" v-if="DM.order_pickup" :peer="peer" />

        <order-user-insurance-card
          v-if="showBuyInsurance"
          :order="DM"
        />

        <!-- 保险详情 -->
        <order-insurance-detail :order="DM" :peer="peer" v-if="DM.order_insurance !== undefined" @refresh="getOrder" />

        <!-- 订单支付金额 -->
        <order-pay-amount :order="DM" v-if="DM.user_order_id" />

        <!-- 回寄地址 -->
        <order-return-address :order="DM" v-if="DM.user_order_id && !DM.hide_return_address" @refresh="getOrder" />

        <!-- 订单详情 -->
        <order-basic-info :order="DM" :peer="peer" v-if="DM.user_order_id" />
      </div>

      <!-- 补缴费用浮层 -->
      <order-repay-diff :unpay-diff="DM.unpaid_price_diff" :order-id="oid" v-if="!DM.enable_api && DM.unpaid_price_diff && hideStaticRepayDiff"></order-repay-diff>
    </div>

    <!-- 补缴费用浮层 -->
    <order-repay-diff :unpay-diff="DM.unpaid_price_diff" :order-id="oid" v-if="!DM.enable_api && DM.unpaid_price_diff" :fixed="false"></order-repay-diff>

    <!-- 重新预约缴费浮层 -->
    <reorder-diff v-if="DM.apply_by" @reOrder="reOrder"></reorder-diff>

    <!-- 优惠券浮层 -->
    <!-- <coupon-modal v-model="showCouponModal" :have-use-now="false" :show-default-title="false" :coupons="unreadCoupons"></coupon-modal> -->

    <!-- 待完善资料浮层 -->
    <wait-complete-material v-model="showCompleteMaterial" :orderData="DM" :unqualifiedMaterial="unqualifiedMaterial"></wait-complete-material>
  </div>
</template>

<script>
import validates from '@/libs/validates';
import { mapState, mapMutations } from 'vuex';
import { SWITCH_MODAL_SHOW, PAY_OK } from '@/store/modules/follow-official-accounts/follow-official-accounts-types';

import utils from '../libs/utils';
import Http from '../libs/http';
import Order from '../libs/order';
import User from '../libs/user';
import orderService from '../services/order-service';
import orderApplicantInfos from '../components/order-detail/order-applicant-infos';
import sfPickupServiceInfo from '../components/order-detail/sf-pickup-service-info';
import orderPayAmount from '../components/order-detail/order-pay-amount';
import orderReturnAddress from '../components/order-detail/order-return-address';

import orderBasicInfo from '../components/order-detail/order-basic-info';
import orderMailList from '../components/order-detail/order-mail-list';
import orderFgNotification from '../components/order-detail/order-fg-notification';
import orderFgDate from '../components/order-detail/order-fg-date';
import orderRejectProduct from '../components/order-detail/order-reject-product';
import orderExpressRoutes from '../components/order-detail/order-express-routes';
import orderElecVisa from '../components/order-detail/order-elec-visa';
import scheduleBlock from '../components/order-detail/schedule-block';
import orderRepayDiff from '../components/order-detail/order-repay-diff';
import reorderDiff from '../components/order-detail/reorder-diff';
import couponModal from '../components/coupon/coupon-modal';
import orderingService from '../services/ordering-service';
import orderInsuranceDetail from './ordering/components/order-insurance-detail';
// import couponService from '../services/coupon-service';
import waitCompleteMaterial from '../components/order-detail/wait-complete-material';
import orderUserInsuranceCard from '../../src/pages/ordering/components/order-user-insurance-card';
import OrderTips from '../components/order-detail/order-tips';
import orderPageCheck from '../components/order-detail/order-page-check.vue';


export default {
  name: 'order-detail',
  components: {
    orderApplicantInfos,
    sfPickupServiceInfo,
    orderPayAmount,
    orderBasicInfo,
    orderMailList,
    orderFgNotification,
    orderFgDate,
    orderRejectProduct,
    orderExpressRoutes,
    orderElecVisa,
    scheduleBlock,
    orderRepayDiff,
    reorderDiff,
    couponModal,
    orderInsuranceDetail,
    waitCompleteMaterial,
    orderReturnAddress,
    OrderTips,
    orderPageCheck,
    orderUserInsuranceCard,
  },
  data() {
    return {
      DM: Order,
      peer_account_id: '',
      oid: +this.$route.params.oid,
      // firstPay: this.$route.query.first_pay,
      hideStaticRepayDiff: true,
      peer: User.peer || {},
      listener: null,
      havePaperyMaterial: false, // 是否有纸质资料
      earlistDateData: null,
      showCouponModal: false,
      unreadCoupons: [],
      showCompleteMaterial: false, // 是否显示待完善资料浮层
      unqualifiedMaterial: [], // 不合格的资料
      showWaitCompleteMaterial: false, // 是否显示待完善资料清单按钮
    };
  },
  computed: {
    ...mapState('followOA', ['mp_watch', 'payok']),

    isFgShow() {
      // 申请人状态:至少有一个处于(待接收资料;等待培训;待前往使馆;预约成功;) 面试
      // 申请人状态:至少有一个处于(待接收资料;等待培训;待前往使馆;预约成功;使馆审核中) 面递
      const need_delivery = this.DM.need_delivery;
      const need_interview = this.DM.need_interview;

      let isApplicantStatusShow;
      if (!need_interview) {

        isApplicantStatusShow = this.DM.applicant &&
        this.DM.applicant.some(
          value =>
            [4, 11, 12, 13, 18].indexOf(value.applicant_status) > -1 ||
            value.interview_status === 1,
        );
      }

      if (!need_delivery) {

        isApplicantStatusShow = this.DM.applicant &&
        this.DM.applicant.some(
          value =>
            [11, 12, 13, 18].indexOf(value.applicant_status) > -1 ||
            value.interview_status === 1,
        );
      }
      return isApplicantStatusShow;
    },
    isWaitOrderShow() {
      // 申请人状态:等待预审;预审未通过;等待预约;退款成功
      const isApplicantStatusShow =
        this.DM.applicant &&
        this.DM.applicant.some(
          value => [1, 2, 9, 8, 17].indexOf(value.applicant_status) > -1,
        );
      // 没有预约成功过但有interview这个属性;且至少有一个是没有修改过
      const hasInterviewButNotOrder =
        this.DM.applicant &&
        this.DM.applicant.some(
          value =>
            value.interview &&
            !value.interview.embassy_address &&
            value.interview_status === 0 &&
            value.interview.date_choice !== undefined,
        );

      return isApplicantStatusShow && hasInterviewButNotOrder;
    },
    hasReturnExpress() {
      return (
        this.DM.return_express &&
        this.DM.return_express[0] &&
        (this.DM.return_express[0].goods_type === 0 ||
          (this.DM.return_express[0].goods_type === 2 &&
            this.DM.return_express[0].express_status === 0))
      );
    },
    hasElecVisa() {
      // 至少有一个有电子签证
      if (this.DM.applicant) {
        return this.DM.applicant.some(value => value.elec_visa && value.elec_visa.length);
      }
    },
    showBuyInsurance() {
      if (!this.DM.user_order_id) return false;
      const order_detail = this.DM;
      //  是否是用户自选保险
      const isUserInsurance = order_detail.product_insurance && order_detail.product_insurance.insurance_type === 1;
      // 是否存在申请人可以购买保险，
      const isSomeApplicantAllowBuy = order_detail.applicant.some((item) => {
        const notBuyApplicantStatus = [6, 7, 8, 14, 15, 16]; // 不能购买保险的申请人状态
        return notBuyApplicantStatus.indexOf(item.applicant_status) === -1 && !item.applicant_insurance;
      });
      // 生效日期是否过期
      const nowDate = new Date();
      const start_date = order_detail.order_insurance ? order_detail.order_insurance.start_date : '';
      const startDateIsExpiration = start_date ? +nowDate >= +new Date(start_date.replace(/-/g, '/')) : false;
      return isUserInsurance && isSomeApplicantAllowBuy && !startDateIsExpiration;
    },
  },
  methods: {
    ...mapMutations('followOA', [SWITCH_MODAL_SHOW, PAY_OK]),

    /**
     * 是否切换邮寄列表显示位置
     * @param {Object} order 订单信息
     * @return {Boolean} 是否展示
     */
    changeMailListPosition(order) {
      if (!order) return true;

      // 已经寄了或者已取件(这要有一个收件成功了,代表至少第一次寄件成功了,也就是签收了)
      if (order.supplier_express && order.supplier_express.length > 0) {
        return order.supplier_express.some(
          express => express.express_status === 1, // 已签收
        );
      }

      // 还没寄或者顺丰待取件
      return false;
    },
    // 获取最早赴馆时间信息
    getEarlistDateData() {
      return orderingService.getEarlistDateData(this.oid).then((data) => {
        this.earlistDateData = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 发送邮件
    sendEmailEvent(email) {
      if (!email) {
        return utils.msg.error('请输入邮箱');
      }
      const { emailReg } = validates.inputRegexpCollection;
      if (!emailReg.test(email)) {
        return utils.msg.error('请输入正确的邮箱格式');
      }
      this.$refs.orderElecVisa.sendEmailDialog = false;
      Http.post('/ssq_elec_visa_email_send', {
        user_order_id: this.oid,
        email,
      }).then((e) => {
        if (e) console.log(e);
        utils.msg.success('发送成功');
      });
    },
    // 重新预约缴费
    reOrder() {
      // 获取重新预约缴费的申请人的订单id数组
      const applicantIdsToChange = this.DM.applicant
        .filter(item => item.interview_status === 2)
        .map(item => item.order_applicant_id);
      this.$router.push({
        name: 'reOrderPay',
        params: { oid: this.oid },
        // 传递申请人数组（先转化为string）
        query: {
          aidArray: JSON.stringify(applicantIdsToChange),
          updateDateType: 2, // 1为修改赴馆时间，2为重新预约缴费
        },
      });
    },

    // 修改赴馆时间类型：1为修改赴馆时间，2为重新预约缴费
    setUpdateDateType(type) {
      this.$refs.orderFgNotification.updateDateType = type;
    },

    getOrder() {
      return Http.post('/order_query', { user_order_id: this.oid }).then((data) => {
        this.DM = data;
        document.title = `${data.country}国家签证办理-上上签同业签证平台，旅游同业签证办理的智能平台`;
        if (this.payok && !this.mp_watch) {
          this.SWITCH_MODAL_SHOW({ show: true });
        }


        utils.extend(Order, data);

        // 是否有纸质资料
        this.havePaperyMaterial = Boolean(
          orderService.isOrderHavePaperyMaterial(data),
        );
        // 如果是面试或面递订单，获取最早赴馆时间信息，里面有每次修改赴馆时间加个字段
        if (this.DM.need_delivery > 0 || this.DM.need_interview > 0) {
          this.getEarlistDateData();
        }

        // 判断是否显示待完善资料清单按钮
        this.isShowWaitCompleteMaterial(data);
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 完善资料
    completeMaterial() {

      // 每一次打开待完善资料浮层都需要重新请求一下数据
      this.getOrder().then(() => {
        this.unqualifiedApplicantNum();

        // 如果所有申请人的资料都已经修改完成
        if (this.unqualifiedMaterial.length === 0) {
          utils.msgbox.alert(
            '全部申请人资料都修改完成，有未提交的申请人，请进入资料详情页面点击“重新提交”按钮',
            '提示', {
              confirmButtonText: '知道了',
            });
        } else {
          this.showCompleteMaterial = true;
        }
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 构造不合格资料数据，有不合格资料的申请人数量
    unqualifiedApplicantNum() {
      const This = this;
      // const num = 0;

      // 先重置旧数据
      this.unqualifiedMaterial = [];

      this.DM.applicant.forEach((el) => {
        const unqualifiedElecMaterial = [];
        const unqualifiedPaperMaterial = [];
        let isFind;

        // 照片
        if (el.id_photo) {
          if (el.id_photo.id_photo_status === 3) {

            // 照片名称固定为：照片
            el.id_photo.elec_name = '照片';

            // 照片资料要求
            const { color, height, width } = this.DM.id_photo;
            const colorName = ['蓝', '白', '红', '灰'][color];
            el.id_photo.attentionArray = [`${colorName}底，${width}×${height}mm`,
              '拍摄时注意光线均匀，不要佩戴眼镜，露出双耳',
              '请用纯色墙做背景，避免衣服与背景色相同',
              '手机拍摄的照片会经过程序检测并自动处理，请申请方提交订单前仔细检查照片是否为满足上述条件'];

            // 将不合格理由转为数组
            el.id_photo.memoArray = el.id_photo.memo.split(/[(\r\n)\r\n]+/);

            unqualifiedElecMaterial.push(el.id_photo);
          }
        }

        // 必需资料
        if (el.material.material_required.length > 0) {
          el.material.material_required.forEach((m) => {

            // 电子资料
            if (m.upload && m.upload.length > 0) {

              // 过滤出多页资料中所有不合格的单页资料（0预审已通过 1待上传资料 2待预审 3预审未通过）
              isFind = m.upload.filter(item => item.elec_status === 3 || item.elec_status === 1);
              if (isFind.length > 0) {

                // 将注意事项转为数组（注意事项有可能没有）
                m.attentionArray = m.attention ? m.attention.split(/[(\r\n)\r\n]+/) : [];

                // 将不合格理由转为数组
                isFind.map(u => u.memoArray = u.memo.split(/[(\r\n)\r\n]+/));
                unqualifiedElecMaterial.push(m);
              }
            } else if (m.express && m.express.length > 0) {
            // 纸质资料

              // 纸质资料的状态更新是新增一条状态，所以只需要取最新一条状态即可
              if (m.express[0].paper_status === 4) {

                // 将注意事项转为数组
                m.attentionArray = m.attention ? m.attention.split(/[(\r\n)\r\n]+/) : [];

                // 将不合格理由转为数组
                m.express[0].memoArray = m.express[0].memo.split(/[(\r\n)\r\n]+/);
                unqualifiedPaperMaterial.push(m);
              }
            }
          });
        }

        // 可选资料
        if (el.material.material_optional.length > 0) {
          el.material.material_optional.forEach((m) => {

            // 电子资料
            if (m.upload && m.upload.length > 0) {

              // 过滤出多页资料中所有不合格的单页资料
              isFind = m.upload.filter(item => item.elec_status === 3 || item.elec_status === 1);
              if (isFind.length > 0) {

                // 将注意事项转为数组
                m.attentionArray = m.attention ? m.attention.split(/[(\r\n)\r\n]+/) : [];

                // 将不合格理由转为数组
                isFind.map(u => u.memoArray = u.memo.split(/[(\r\n)\r\n]+/));
                unqualifiedElecMaterial.push(m);
              }
            } else if (m.express && m.express.length > 0) {
            // 纸质资料

              // 纸质资料的状态更新是新增一条状态，所以只需要取最新一条状态即可
              if (m.express[0].paper_status === 4) {

                // 将注意事项转为数组
                m.attentionArray = m.attention ? m.attention.split(/[(\r\n)\r\n]+/) : [];

                // 将不合格理由转为数组
                m.express[0].memoArray = m.express[0].memo.split(/[(\r\n)\r\n]+/);
                unqualifiedPaperMaterial.push(m);
              }
            }
          });
        }

        // 申请表（申请表放到电子资料类型的最后）
        if (el.application) {
          if (el.application.application_status === 3) {

            // 申请表名称固定为：签证申请表
            el.application.elec_name = '签证申请表';

            // 申请表资料要求固定为：无资料要求；
            el.application.attentionArray = ['无资料要求'];

            // 将不合格理由转为数组
            el.application.memoArray = el.application.memo.split(/[(\r\n)\r\n]+/);

            unqualifiedElecMaterial.push(el.application);
          }
        }

        // 根据是否有不合格的电子/纸质资料构造数据
        if (unqualifiedElecMaterial.length > 0 || unqualifiedPaperMaterial.length > 0) {
          This.unqualifiedMaterial.push({});
          This.unqualifiedMaterial[This.unqualifiedMaterial.length - 1].applicant_name = el.applicant_name;
          This.unqualifiedMaterial[This.unqualifiedMaterial.length - 1].identity = el.identity;
          if (unqualifiedElecMaterial.length > 0) {
            This.unqualifiedMaterial[This.unqualifiedMaterial.length - 1].unqualifiedElecMaterial = unqualifiedElecMaterial;
          }
          if (unqualifiedPaperMaterial.length > 0) {
            This.unqualifiedMaterial[This.unqualifiedMaterial.length - 1].unqualifiedPaperMaterial = unqualifiedPaperMaterial;
          }
        }
      });
    },

    // 判断订单内容是否有预审不通过的申请人。是否显示待完善资料清单
    isShowWaitCompleteMaterial(data) {

      // 订单中有申请人的状态是“预审未通过”
      const isFind = data.applicant.find(item => item.applicant_status === 2);

      this.showWaitCompleteMaterial = !!isFind;
    },
  },
  mounted() {
    // 立即加入的悬浮栏的滚动事件
    window.addEventListener(
      'scroll',
      utils.debounce(() => {
        const windowHeight = document.documentElement.clientHeight;
        const bodyScrollTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        const bodyScrollHeight = document.body.scrollHeight;

        if (
          windowHeight + bodyScrollTop <
          bodyScrollHeight - document.querySelector('#footer').scrollHeight
        ) {
          this.hideStaticRepayDiff = true;
        } else {
          this.hideStaticRepayDiff = false;
        }
      }, 0),
    );
  },

  beforeRouteLeave(to, from, next) {
    window.onscroll = null;
    next();
  },

  created() {
    this.getOrder();

    Http.post('/peer_account_query', {}).then((data) => {
      this.peer_account_id = data.peer_account_id;
    }).catch((e) => {
      if (e) console.log(e);
    });

    if (!User.peer || !User.peer.visa_peer_id) {
      Http.post('/visa_peer_query').then((data) => {
        this.peer = data;
        User.peer = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    }
  },
};
</script>

<style lang="less" scoped>
.view-order {
  width: 920px;
  margin: auto;
  padding-bottom: 100px;

  .hierarchy {
    line-height: 56px;
  }

  .order-main {
    background-color: #f7f8fa;
    .order-page-check {
      margin-bottom: 15px;
    }
    .none-margin {
      margin-top: 0;
    }
    .module-margin {
      margin-top: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/OrderDetail.vue